import styled from "styled-components";

const FormWrapper = styled.form`
  label {
    font-size: 18px;
  }
  input[type="text"],
  input[type="password"] {
    font-size: 18px;
    font-family: "Roboto", sans-serif;
    width: 100%;
    padding: 15px;
    margin: 0.5rem 0 1rem;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    border: 2px solid rgba(0, 0, 0, 0);
    outline: none;
    &::placeholder {
      font-size: 14px;
    }
  }
  input:focus {
    border-color: ${(props) => props.theme.primaryBlue};
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.11);
  }
  button {
    width: 100%;
    font-size: 20px;
    color: white;
    padding: 20px;
    position: relative;
    border-radius: 4px;
    background: ${(props) => props.theme.primaryBlue};
    opacity: 1;
    transition: all 300ms ease;
  }
  button::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 300ms ease;
    box-shadow: 0 20px 38px rgba(0, 0, 0, 0.16);
  }
  button:hover {
    transform: translateY(-3px);
    opacity: 0.87;
  }
  button:hover {
    &::after {
      opacity: 1;
    }
  }
  button:active {
    transform: translateY(-1px);
  }
  a,
  .toggleLogin {
    color: ${(props) => props.theme.primaryBlue};
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export default FormWrapper;
